import { find } from 'lodash'
import customFilterResource from '@/api/resources/ui/CustomFilterResource'
import customConfigResource from '@/api/resources/ui/CustomConfigResource'
import sideBarOptions from './registryCaseSideBarOptions'
import ExpandedSideBar from '@/components/sideBar/ExpandedSideBar'
import CompactSideBar from '@/components/sideBar/CompactSideBar'

class RegistryCaseSideBarStore {
    constructor() {
        this.sideBars = [ ExpandedSideBar, CompactSideBar ]
        this.loadedCustomOptions = false
        this.loadedConfig = false
        this.firstLevel = sideBarOptions.expanded.reduce((prev, next) => next.children && next.children.children ? prev.concat(next.children.children) : prev.concat(next.children), [])
        this.completeArray = this.firstLevel.reduce((prev, next) => next && next.children ? prev.concat(next.children) : prev.concat(next), [])
        this.defaultOption = this.completeArray.find(obj => obj.id === 'registryToday')
        this.state = {
            componentCode: 'uicomponent.registry.casepanel',
            options: sideBarOptions,
            sideBar: ExpandedSideBar,
            fallbackOption: this.defaultOption,
            selectedOption: null,
            sideBarName: sideBarOptions.sideBarName,
            gridRouteName: 'caseGrid',
            cardIndexRouteName: 'registryRequestCardIndex',
            customOptions: [],
            config: this.getDefaultConfig()
        }
    }
    getDefaultConfig() {
        return {
            defaultOptionId: null,
            sideBarName: ExpandedSideBar.name
        }
    }
    hasLoaded() {
        return this.loadedCustomOptions && this.loadedConfig
    }
    expandSideBar() {
        this.state.sideBar = ExpandedSideBar
        this.saveConfig()
    }
    contractSideBar() {
        this.state.sideBar = CompactSideBar
        this.saveConfig()
    }
    contractSideBarLocally() {
        this.state.sideBar = CompactSideBar
    }
    selectDefaultOption() {
        const option = this.findOptionById(this.state.config.defaultOptionId)
        if (!option) {
            console.warn(`customOption with id ${this.state.config.defaultOptionId} does not exist, selecting fallback option`)
            this.selectFallbackOption()
            return
        }
        this.setSelectedOption(option)
    }
    selectFallbackOption() {
        this.setSelectedOption(this.state.fallbackOption)
    }
    findOptionById(id) {
        const predicate = o => o.id === id
        return find(this.completeArray, predicate) || find(this.state.customOptions, predicate)
    }
    setSelectedOption(option) {
        this.state.selectedOption = option
    }
    setDefaultOption(option) {
        this.state.config.defaultOptionId = option && option.id
    }
    async loadCustomOptions() {
        const customOptions = await customFilterResource.indexAsOptions(this.state.componentCode)
        this.setCustomOptions(customOptions)
        this.loadedCustomOptions = true
    }
    setCustomOptions(customOptions) {
        this.state.customOptions = customOptions
    }
    async removeCustomOption(option) {
        const index = this.state.customOptions.findIndex(i => i.id === option.id)
        if (index === -1) {
            throw new Error(`custom option with id ${option.id} does not exist`)
        }
        await customFilterResource.deleteCustomOption(this.state.componentCode, option)
        if (option.id === this.state.selectedOption.id) {
            this.setSelectedOption(this.defaultOption)
        }
        this.state.customOptions.splice(index, 1)
    }
    async renameCustomOption(option) {
        await customFilterResource.renameCustomOption(this.state.componentCode, option)
        await this.loadCustomOptions()
        this.updateSelectedOption()
    }
    async updateCustomOption(option, filterModel) {
        return customFilterResource.updateCustomOption(this.state.componentCode, option, filterModel)
    }
    updateSelectedOption() {
        const customOptionSelectedOption = this.state.customOptions.find(customOption => customOption.id === this.state.selectedOption?.id)
        if (customOptionSelectedOption) {
            this.setSelectedOption(customOptionSelectedOption)
        }
    }
    async loadConfig() {
        const customConfig = await customConfigResource.get(this.state.componentCode)
        if (customConfig) {
            this.setConfig({ ...this.getDefaultConfig(), ...customConfig.config })
        } else {
            this.setConfig(this.getDefaultConfig())
        }
        this.loadedConfig = true
    }
    setConfig(config) {
        this.state.config = config
        this.applyConfigSideBar()
    }
    applyConfigSideBar() {
        const sideBar = this.sideBars.find(i => i.name === this.state.config.sideBarName)
        if (!sideBar) {
            throw new Error(`sideBar named ${this.state.config.sideBarName} not found`)
        }
        this.state.sideBar = sideBar
    }
    async saveConfig() {
        const config = {
            ...this.state.config,
            sideBarName: this.getCurrentSideBarName()
        }
        await customConfigResource.save(this.state.componentCode, config)
        this.state.config = config
    }
    getCurrentSideBarName() {
        if (!this.state.sideBar) {
            throw new Error('state.sideBar is not set')
        }
        return this.state.sideBar.name
    }
}

export default new RegistryCaseSideBarStore()
